import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface MarkdownViewerProps {
  content: string
}

/**
 * 작업 문서 마크다운 렌더러.
 * - remark-gfm 으로 표/체크박스/취소선/자동링크 지원
 * - Tailwind typography(prose) 로 라이트/다크 스타일
 * - raw HTML 은 렌더하지 않음(react-markdown 기본값) → XSS 안전
 */
function MarkdownViewer({ content }: MarkdownViewerProps) {
  return (
    <div className="prose prose-sm max-w-none dark:prose-invert prose-headings:font-semibold prose-headings:text-gray-900 prose-a:text-indigo-600 prose-code:rounded prose-code:bg-gray-100 prose-code:px-1 prose-code:py-0.5 prose-code:before:content-none prose-code:after:content-none prose-pre:bg-gray-100 prose-pre:text-gray-800 prose-table:text-sm prose-th:border prose-th:border-gray-300 prose-th:bg-gray-50 prose-th:px-3 prose-th:py-2 prose-td:border prose-td:border-gray-300 prose-td:px-3 prose-td:py-2 dark:prose-headings:text-white dark:prose-a:text-indigo-400 dark:prose-code:bg-gray-800 dark:prose-pre:bg-gray-800 dark:prose-pre:text-gray-200 dark:prose-th:border-gray-600 dark:prose-th:bg-gray-800 dark:prose-td:border-gray-600">
      <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
    </div>
  )
}

export default MarkdownViewer
